var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HomepageWideLayout',{attrs:{"heroDark":""}},[_c('section',[_c('SecondaryHeader',[_c('h2',[_vm._v("Artwork Guidelines")]),_vm._v(" "),_c('p',{staticClass:"body"},[_vm._v("\n        Review our tips for creating a design that will generate a flawless ready-to-use online print template.\n\n\n      ")])]),_vm._v(" "),_c('ArtworkTips')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c2c89c8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/homepage/ArtworkGuidelines.vue
// module id = C1V3
// module chunks = 1